type QueryKey = readonly unknown[];

type QueryKeyFunction = (...args: any[]) => QueryKey;

type QueryKeyFactory = QueryKey | QueryKeyFunction;

type ServiceKey<TService> = {
  [K in keyof TService]?: QueryKeyFactory;
};

export abstract class QueryKeyService<TService> {
  constructor(
    private readonly baseKey: string,
    private readonly queryKeys: Omit<ServiceKey<TService>, 'getKeys'>,
  ) {
    this.baseKey = baseKey;
    this.queryKeys = queryKeys;
  }

  public getKeys(key: keyof Omit<TService, 'getKeys'>, ...args: any[]) {
    const queryKeys = this.queryKeys[key];
    return typeof queryKeys === 'function'
      ? [this.baseKey, ...queryKeys(args)]
      : [this.baseKey, ...(queryKeys as Array<unknown>)];
  }
}
